import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UpdateOrderModel } from '../../models/update-order-model';
import {
  Update,
  UpdateOrderService,
} from '../../services/update-order/update-order.service';
import { UpdateOrderDialogComponent } from '../update-order-dialog/update-order-dialog.component';

@Component({
  selector: 'app-update-order',
  templateUrl: './update-order.component.html',
  styleUrls: ['./update-order.component.scss'],
  standalone: false,
})
export class UpdateOrderComponent implements OnInit, OnDestroy {
  dialog = inject(MatDialog);
  private updateOrderService = inject(UpdateOrderService);
  private datePipe = inject(DatePipe);

  @Input() public order!: Order;
  private destroy$: Subject<Update> = new Subject<Update>();
  public isUpdateInPending = false;
  public updateOrderModel: UpdateOrderModel = {};

  ngOnInit(): void {
    this.updateOrderModel.order = cloneDeep(this.order);
    this.updateOrderModel.originalOrder = cloneDeep(this.order);
    if (this.order.pendingUpdateDate) {
      this.isUpdateInPending = true;
    }
    this.updateOrderService.pendingUpdate$
      .pipe(takeUntil(this.destroy$))
      .subscribe((update: Update) => {
        if (update.id === this.order.id) {
          if (update.currentAction === 'close') {
            this.updateOrderModel.order = cloneDeep(this.order);
          } else if (update.currentAction === 'update') {
            this.isUpdateInPending = true;
            this.order.pendingUpdateDate =
              update.orderAfterPendingUpdate?.pendingUpdateDate;
          } else {
            this.openDialog();
          }
        }
      });
  }

  get pendingUpdateIconData(): { badgeIcon: string; toolTip: string } {
    return {
      badgeIcon: 'pending grey-color',
      toolTip: $localize`:@@UpdateOrderPendingTooltip:Order updated on ${this.datePipe.transform(
        this.order.pendingUpdateDate,
        'dd MMM yyyy',
      )}`,
    };
  }

  openDialog(): void {
    if (!this.isUpdateInPending) {
      this.dialog.open(UpdateOrderDialogComponent, {
        data: { model: this.updateOrderModel, focusTabIndex: 0 },
        panelClass: 'update-order-dialog-panel',
        height: '85vh',
        width: '70vw',
        position: { top: '4rem' },
        disableClose: true,
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
